export default class Movie {
  constructor() {
    this.movieButtons = document.querySelectorAll('.js-movie-button');
    this.movieContents = document.querySelectorAll('.js-movie__content');
    this.movieVideos = document.querySelectorAll('.js-movie-video');
    
    if (this.movieButtons.length > 0) {
      this.init();
    }
  }

  init() {
    this.setupEventListeners();
  }

  setupEventListeners() {
    // .js-movie-buttonのクリックイベント
    this.movieButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        this.handleMovieButtonClick(button);
      });
    });


    // .js-movie-video以外のクリックイベント
    document.addEventListener('click', (e) => {
      const isMovieVideo = e.target.closest('.js-movie-video');
      const isMovieButton = e.target.closest('.js-movie-button');
      
      if (!isMovieVideo && !isMovieButton) {
        this.closeAllMovies();
      }
    });
  }

  handleMovieButtonClick(clickedButton) {
    // 他の動画をすべて閉じる
    this.closeAllMovies();
    
    // .js-movie__contentと動画を直接検索（位置が変更されたため）
    const targetContent = document.querySelector('.js-movie__content');
    const targetVideo = document.querySelector('video.js-movie-video');
    
    if (targetContent) {
      targetContent.classList.add('is-active');
    }
    
    if (targetVideo) {
      this.playVideo(targetVideo);
    }
  }


  playVideo(video) {
    if (video && video.tagName === 'VIDEO') {
      video.currentTime = 0; // 頭出し
      video.muted = true; // ミュートを確実に設定
      video.play().catch(error => {
        console.warn('動画の再生に失敗しました:', error);
        // 再生に失敗した場合のフォールバック
        console.log('動画要素:', video);
        console.log('動画のsrc:', video.src);
        console.log('動画のreadyState:', video.readyState);
      });
    } else {
      console.warn('動画要素が見つかりません:', video);
    }
  }

  pauseVideo(video) {
    if (video && video.tagName === 'VIDEO') {
      video.pause();
      video.currentTime = 0; // 頭出し
    }
  }

  closeAllMovies() {
    // すべてのコンテンツからis-activeクラスを削除
    this.movieContents.forEach(content => {
      content.classList.remove('is-active');
    });
    
    // すべての動画を停止して頭出し
    this.movieVideos.forEach(video => {
      this.pauseVideo(video);
    });
  }
}
